import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import usetransProposal from "../../store/quotation/detailTransPropo";
import usequotation from "../../store/quotation/storeQuotation";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { getProductsByVendeur } from "../../lib/apis";
import Loader from "../../components/loader";
import { FaArrowLeft } from "react-icons/fa";
import Breadcrumb from "../../components/Breadcrumb";
import { scrollToTop } from "../../lib/utils";

const DetailTrans = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const [products, setProducts] = useState<any>()
  const [loader, setLoader] = useState(true)
  const data = location.state
  const navigate = useNavigate();
  const user = JSON.parse(data)
  const { transProposal, loadingDetail, fetchtransProposal } =
    usetransProposal();
  const ProposalId = useParams().id;

  useEffect(() => {
    scrollToTop()
  }, [])

  const { quotation_id } = usequotation();

  useEffect(() => {
    if (quotation_id && ProposalId) {
      fetchtransProposal(quotation_id, ProposalId);
    }
  }, [fetchtransProposal, quotation_id, ProposalId]);

  useEffect(() => {
    console.log("Quotation ID:", quotation_id);
    // const updateProducts = async () => {
    //   try {
    //     const { data } = await axios.get(`${getProductsByVendeur}/${ProposalId}/assets`)
    //     console.log("acteurs", data.products ? data.products : data.vehicles)
    //     // setProducts(data.products.lenght? data.products : data.vehicles)
    //     setProducts(data)
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     setLoader(false)
    //   }
    // }
  }, [quotation_id]);

  // console.log("User:", user);
  const updateProducts = async () => {
    try {
      const { data } = await axios.get(`${getProductsByVendeur}/${user.id}/assets`)
      console.log("acteurs", data.vehicles)
      // setProducts(data.products.lenght? data.products : data.vehicles)
      setProducts(data.vehicles)
    } catch (error) {
      console.log(error)
    } finally {
      setLoader(false)
    }
  }
  useEffect(() => {
    updateProducts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  if (loadingDetail) {
    return <div>Loading...</div>;
  }
  // console.log(transProposal)



  return (
    <div className="container mx-auto p-6 bg-gray-100 min-h-screen">
      <div className="flex flex-row py-5  items-center justify-start w-full ">
        <FaArrowLeft
          onClick={() => navigate(-1)}
          className="  text-green-500 text-3xl"
          style={{ cursor: "pointer" }}
        />
        <Breadcrumb />
      </div>
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        {t("detail_transporteur")}
      </h2>

      {/* User and Proposal Information */}
      <div className="bg-white shadow rounded-lg p-6 mb-6">
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          {t("transporteur_information")}
        </h3>
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-4">
            <img
              src={user.image}
              alt="Avatar"
              className="w-16 h-16 rounded-full object-cover"
            />
            <div>
              <p className="text-gray-800 font-medium text-lg">
                {transProposal?.user.name}
              </p>
              <p className="text-gray-600 text-sm">
                {transProposal?.user.city}
              </p>
              <p className="text-gray-600 text-sm">
                {transProposal?.user.address}
              </p>
            </div>
          </div>
          <div className="text-gray-800 text-lg font-semibold mt-3">
            {t("prix_propose")}: {user?.price} F
          </div>
        </div>
      </div>

      {/* Vehicles Information */}
      <div className="bg-white shadow rounded-lg p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          {t("liste_vehicule")}
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {loader ? <Loader /> : products?.map((vehicle: any) => (
            <div
              key={vehicle.vehicle_profile_id}
              className="border border-gray-200 rounded-lg shadow-md p-4"
            >
              <img
                src={JSON.parse(vehicle.images)[0]}
                alt={vehicle.name}
                className="w-full h-32 object-cover rounded-md mb-3"
              />
              <h4 className="text-md font-semibold text-gray-800">
                {vehicle.name} - {vehicle.model}
              </h4>
              <p className="text-gray-600 text-sm">
                {t("condition")}: {vehicle.condition}
              </p>
              <p className="text-gray-600 text-sm">
                {t("licence_plate")}: {vehicle.license_plate}
              </p>
              <p className="text-gray-600 text-sm">Region: {vehicle.region}</p>
              <p className="text-gray-600 text-sm mt-2">
                {vehicle.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DetailTrans;
